<template>
  <div class="base-card-to-listen">
    <base-card>
      <!-- <p class="eae-title">{{title}}</p> -->
      <base-question
        :text="title"
        :class="sizes.length > 1 ? 'mb_25' : 'mb_25'"
      />

      <div v-for="(element, elementIndex) in elements" :key="elementIndex">
        <div v-if="sizes.length > 1" class="d-flex align-center mb_10">
          <!--
              INSTRUÇÕES COLLAPSE
              - O collapse pode ser aberto clicando no botão de chevron ou dando focus no input de nome do extra
              - Ao abrir um collpase, os outros devem fechar, como um accordion.
              - O collapse fecha em duas ocasiões, clicando novamente no botão de chevron ou abrindo outro collapse
              - Não há collapse no modo de exclusão (deleteMode), então todos devem ser fechados ao ativar o modo de remoção.
          -->
          <base-input
            :ref="`nameInput${elementIndex}`"
            :label="elementPlaceholder"
            v-model="element.name"
            class="mb_5 p_0 mr_10 w-100"
          />
          <base-button
            v-if="!deleteMode"
            class="eae-collapse-btn mb_5"
            design="four"
            @click.prevent="
              toggleThisElement(elementIndex, !collapseStatus[elementIndex])
            "
          >
            <i
              v-show="collapseStatus[elementIndex]"
              class="fal fa-chevron-down"
            ></i>
            <i
              v-show="!collapseStatus[elementIndex]"
              class="fal fa-chevron-up"
            ></i>
          </base-button>
        </div>
        <div v-else class="d-flex align-center mb_10">
          <base-input
            :label="elementPlaceholder"
            v-model="element.name"
            :disabled="deleteMode"
            class="pr_5 mb_5 w-100 pt_0"
            :class="{ pt_0: elementIndex == 0 }"
            :ref="`nameInput${elementIndex}`"
          />
          <div class="pl_5" :class="!!deleteMode ? 'mb_5' : ''">
            <base-button
              v-if="deleteMode"
              :text="StringLanguage.delete"
              class="w-100 big"
              design="four"
              @click.prevent="deleteItem(element)"
            />
            <base-input
              v-else
              :type="'tel'"
              class="mb_5 pt_0"
              v-model="element.sizes[0].price"
              :money-mask="StringLanguage.currencyConfigs"
              :class="{ pt_0: elementIndex == 0 }"
              :ref="`priceInput${elementIndex}`"
            />
          </div>
        </div>

        <div
          v-if="!deleteMode && !collapseStatus[elementIndex] && sizes.length > 1"
        >
          <div
            v-for="(elementSize, sizeIdx) in getSizesByElement(element)"
            :key="sizeIdx"
          >
            <!-- v-for pra cada tamanho -->
            <div class="d-flex align-center">
              <base-input

                class="pr_5 mb_5 w-100"
                :value="elementSize.name"
                :disabled="elementSize.name !== ''"
                @focus="checkSizeName(elementSize.name)"
              />
              <div class="wpx-min-120 wpx-120">
                <base-input

                  :type="'tel'"
                  v-model="elementSize.price"
                  class="pl_5 mb_5"
                  :money-mask="StringLanguage.currencyConfigs"
                />
              </div>
            </div>
          </div>
          <base-button
            :text="'Remover'"
            :design="'underline mb_15'"
            class="m_auto"
            @click.prevent="deleteItem(element)"
          >
          </base-button>
        </div>
      </div>

      <div class="w-100 d-flex mt_20">
        <base-button
          :text="
            sizes.length > 1 ?
              collapseStatus.filter((c) => !c).length > 0 ?
              finishButtonText :
              addButtonText :
            addButtonText
          "
          design="two"
          class="w-100 mr_5"
          @click.prevent="closeOrAddItem"
        />
        <base-button
          v-if="elements.length > 0 && sizes.length <= 1"
          :text="!deleteMode ? 'Remover' : 'Voltar'"
          design="four"
          class="w-100 ml_5"
          @click.prevent="toggleDeleteMode(!deleteMode)"
        />
      </div>
    </base-card>
  </div>
</template>

<script>
import Vue from "vue";
import BaseCard from "@/components/Card";
import BaseInput from "@/components/Input";
import BaseButton from "@/components/Button";
import BaseQuestion from "@/components/Question";

export default {
  components: {
    BaseCard,
    BaseInput,
    BaseButton,
    BaseQuestion,
  },

  props: {
    title: { type: String },
    elementPlaceholder: { type: String },
    addButtonText: { type: String, default: "Adicionar" },
    finishButtonText: { type: String, default: "Concluir" },
    deleteMode: { type: Boolean, default: false },
    sizes: { type: Array, default: [] },
    elements: { type: Array, default: [] },
  },
  data() {
    return {
      collapseStatus: this.$props.elements.map((s) => true),
    };
  },
  updated(){
    const refKeys = Object.keys(this.$refs);

    refKeys.forEach(inputRef => {
      if (inputRef.includes('nameInput')) {
        if (this.$refs[inputRef] && this.$refs[inputRef].length > 0) {
          if (this.$refs[inputRef][0].value === '') {
            this.$refs[inputRef][0].focus();

            const priceInputRef = `priceInput${inputRef.replace('nameInput', '')}`;
            this.$refs[priceInputRef] && this.$refs[priceInputRef].length > 0 && (this.$refs[priceInputRef][0].value = 0);
          }
        }
      }
    });
  },
  methods: {
    getSizesByElement(element) {
      return this.$props.sizes.map((s) => {
        let matchSize = element.getItemsByParam("_id", s._id);
        return matchSize.length > 0 ? matchSize[0] : s;
      });
    },
    toggleThisElement(elementIndex, show) {
      this.collapseStatus = this.collapseStatus.map(() => true);
      this.collapseStatus[elementIndex] = show;
    },
    checkSizeName(name) {
      if (name === '') alert('Você não configurou o nome dos tamanhos.');
    },
    applyPrice(size, price) {},
    onChanged() {
      //Emitir evento de alteração
    },
    addNewItem() {
      const itemPosition = this.collapseStatus.length;
      this.collapseStatus = this.collapseStatus.map(() => true);
      this.collapseStatus[itemPosition] = false;
      this.$emit("addNewItem");
    },
    deleteItem(elm) {
      this.collapseStatus.splice(this.collapseStatus.length - 1, 1);
      this.$emit("removeElement", elm);
      return false;
    },
    toggleDeleteMode(activate) {
      this.$emit("deleteMode", activate);
    },
    closeOrAddItem() {
      const isEditing = this.collapseStatus.filter((c) => !c).length > 0;
      if (isEditing && this.sizes.length > 1) {
        this.collapseStatus = this.collapseStatus.map(() => true);
      } else {
        this.addNewItem();
      }
    },
  },
};
</script>
<style scoped>
/* .eae-title {
  font-size: 1.4em;
  padding: 16px 0 15px 0;
  text-align: center;
  width: 100%;
  background: #eee;
  margin-bottom: 25px;
  color: #999;
} */

.eae-collapse-btn {
  font-size: 1.2em;
  min-width: 50px;
  width: 50px;
  min-height: 45px;
}
</style>